<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Remarcar Encontro' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content class="forms-validations-content">
  <div class="gradient-extendido"></div>

  <div class="div-top">
    <ion-note slot="start">
      <i class="fa-solid fa-square-poll-horizontal"></i>
    </ion-note>
    <ion-label>{{'Dados do encontro' | translate}}</ion-label>
  </div>

  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <div class="border-bottom ion-margin-horizontal">
      <prover-datepicker
        [labelName]="'Data'"
        [id]="'data'"
        formControlName="data"
        [required]="true"
        [disabled]="validations_form.get('data')?.disabled ?? false"
      ></prover-datepicker>
    </div>

    <div class="border-bottom ion-margin-horizontal ion-margin-top">
      <app-prover-horas
        [labelName]="'Hora'"
        [id]="'hora'"
        formControlName="hora"
        [required]="true"
        [isLabel]="true"
        [disabled]="validations_form.get('hora')?.disabled ?? false"
      ></app-prover-horas>
    </div>

    <ion-row class="d-flex ion-margin-top">
      <ion-col size="8" class="d-flex">
        <ion-button
          class="btn-default btn-custom"
          exapand="block"
          type="submit"
          [disabled]="!validations_form.valid || !isHoje"
        >
          {{'Remarcar' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </form>

  <div *ngIf="userProvider.hasConfig(100) && mda.dadosMDA.frequenciaDias" class="validation-errors">
    <ng-container>
      <div class="error-message" *ngIf="isHoje">
        {{'O encontro pode ser remarcado entre as datas' | translate}} {{hoje | dateFormat:'ddmmyyyy'}} {{'Até' |
        translate}} {{dataFinal | dateFormat:'ddmmyyyy'}}
      </div>

      <div class="error-message" *ngIf="!isHoje">
        {{'O encontro só pode ser remarcado até um dia antes do próximo encontro' | translate}}
      </div>
    </ng-container>
  </div>
</ion-content>
